import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

/**
 * @param value The number to format.
 * @param digits The number of digits to display after the decimal point.
 *
 * @returns The formatted currency value.
 *
 */
@Pipe({ name: 'shortCurrencyPipe' })
export class ShortCurrencyPipe implements PipeTransform {
  transform(value: number, digits: number = 1): string | null {
    if (value === null || value === 0.0 || value === undefined || value === 0) {
      return '$0';
    }
    const formatter = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
    });
    return `$${formatter.format(value)}`;
  }
}
